import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandshake = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22 16L19.828 18.172C19.0779 18.9219 18.0607 19.3432 17 19.3432C15.9393 19.3432 14.9221 18.9219 14.172 18.172L14 18L18.929 13.071C20.2552 11.7452 22.0537 11.0004 23.929 11.0004C25.8043 11.0004 27.6028 11.7452 28.929 13.071V13.071C30.0427 14.1849 30.7528 15.6385 30.9468 17.2016C31.1408 18.7647 30.8076 20.3478 30 21.7",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.266 19.266L26.879 22.879C27.4414 23.4416 27.7573 24.2045 27.7573 25C27.7573 25.7955 27.4414 26.5584 26.879 27.121L25.243 28.757C24.6858 29.3143 24.0243 29.7563 23.2963 30.0579C22.5683 30.3595 21.788 30.5147 21 30.5147C20.212 30.5147 19.4317 30.3595 18.7037 30.0579C17.9756 29.7563 17.3142 29.3143 16.757 28.757L11.071 23.071C9.74513 21.7448 9.00031 19.9463 9.00031 18.071C9.00031 16.1957 9.74513 14.3972 11.071 13.071V13.071C12.3782 11.7601 14.1488 11.0162 16 11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.391 27.609L22.5 23.719",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.513 29.965L19.883 26.335",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgHandshake);
export default ForwardRef;
